<template>
  <div class="navigation">
    <div class="nav" v-if="!title">
      <span class="logo"></span>
      <span class="tour" @click="isShow" v-if="!isNavigation"></span>
      <span class="tour-close" @click="isHide" v-else></span>
    </div>
    <van-nav-bar v-else :title="title" @click-left="onClickLeft(title)" fixed placeholder class="navigation-van">
      <template #left>
        <svg-icon iconClass='return' className='icon'></svg-icon>
      </template>
      <template #right>
        <span class="van-tour" @click="isShow" v-if="!isNavigation"></span>
        <span class="van-close" @click="isHide" v-else></span>
      </template>
    </van-nav-bar>
    <div class="navigation-content" v-if="isNavigation">
      <div class="navigation-content-list" v-for="item in navigationList" @click="goLink(item.link)">
        <p>{{ item.name }}</p>
        <svg-icon :iconClass='item.icon' className='nav-icon'></svg-icon>
      </div>
      <div class="navigation-content-list" @click="login" v-if="isState">
        <p>登录</p>
        <svg-icon iconClass='nav7' className='nav-icon'></svg-icon>
      </div>
      <div class="navigation-content-list" @click="exit" v-else>
        <p>退出</p>
        <svg-icon iconClass='nav8' className='nav-icon'></svg-icon>
      </div>
    </div>
  </div>
</template>

<script>

import '../assets/font/font.css'
import QRCode from 'qrcodejs2'
import {Dialog} from 'vant'
import {request} from "../untils/request";

export default {
  name: 'navigation',
  data () {
    return {
      isNavigation: false,
      navigationList: [
        {
          name: '首页',
          link: 'home',
          icon: 'nav1'
        },
        {
          name: '信息资讯',
          link: 'information',
          icon: 'nav2'
        },
        {
          name: '资源阅读',
          link: 'resource',
          icon: 'nav3'
        },
        {
          name: '个人中心',
          link: 'personal',
          icon: 'nav4'
        },
        {
          name: '请您关注',
          link: 'application',
          icon: 'nav5'
        },
        // {
        //   name: '文津诵读',
        //   link: 'poetryRead',
        //   icon: 'nav11'
        // }
      ],
      sites: ['wechat'],
      sitesWb: ['weibo'],
      showShare: false,
      showShareWb: false,
      name: document.title,
      wxShow: false,
      isState: true,
      isShowList: [],
    }
  },
  props: {
    title: {
      type: String
    }
  },
  created () {
    if (this.$cookies.get('accessToken')) {
      this.isState = false
    } else {
      this.isState = true
    }
    this.getModule ()
  },
  methods: {
    // 获取显示模块
    getModule () {
      request('get', '/nlc-web/api/control/module').then(res => {
        console.log('显示模块', res)
        let content = res.data.content
        content.forEach(item => {
          if (item.status === 'SUCCESS') {
            this.isShowList[item.name] = {
              status: item.status,
              sort: item.sort
            }
          }
        })
        if(this.isShowList.hasOwnProperty('读者指南')){
          this.navigationList.push({
            name: '读者指南',
            link: 'guide',
            icon: 'nav6'
          })
        }
        if(this.isShowList.hasOwnProperty('专题展览')){
          this.navigationList.push({
            name: '专题展览',
            link: 'projectList',
            icon: 'nav12'
          })
        }
        if(this.isShowList.hasOwnProperty("文津经典诵读")){
          this.navigationList.push({
            name: '文津诵读',
            link: 'poetryRead',
            icon: 'nav11'
          })
        }
        if(this.isShowList.hasOwnProperty("调查问卷")){
          this.navigationList.push({
            name: '问卷调查',
            link: 'questionList',
            icon: 'nav13'
          })
        }
      })
    },
    qrcodeCode () {
      document.getElementById('qrcode').innerHTML = ''
      new QRCode('qrcode', {
        width: 100,
        height: 100,
        text: location.href, // 二维码地址
        colorDark: '#000',
        colorLight: '#fff'
      })
    },
    onClickLeft (title) {
      if(title==='读者问卷调查'){
        this.$router.push({path: `/`})
        this.isNavigation = false
        document.body.style.overflow = 'scroll'
      } else {
        this.isNavigation = false
        document.body.style.overflow = 'scroll'
        this.$router.go(-1)
      }
    },
    isShow () {
      this.isNavigation = true
      document.body.style.overflow = 'hidden'
    },
    isHide () {
      this.isNavigation = false
      document.body.style.overflow = 'scroll'
    },
    goLink (link) {
      this.isNavigation = false
      console.log('link', link)
      document.body.style.overflow = 'scroll'
      this.$router.push({
        name: link
      })
    },
    getShow (msg) {
      this.showShare = msg
    },
    getShowWb (msg) {
      this.showShareWb = msg
    },
    shareWx () {
      this.qrcodeCode()
      if (this.wxShow === true) {
        this.wxShow = false
      } else {
        this.wxShow = true
      }
    },
    shareWb () {
      let param = {
        url: location.href,
        appkey: '1343713053', /** 您申请的应用appkey,显示分享来源(可选)*/
        title: document.title, /** 分享的文字内容(可选，默认为所在页面的title)*/
      }
      let temp = [];
      for( let p in param ){
        temp.push(p + '=' + encodeURIComponent( param[p] || '' ) )
      }
      let target_url = "http://service.weibo.com/share/share.php?"+temp.join('&');
      window.open(target_url, 'sinaweibo')
    },
    // 登录
    login () {
      document.body.style.overflow = 'scroll'
      let url = encodeURI(window.location.href)
      window.location.href = process.env.API_ROOT + '/nlc-api/api/nlc/login?paramUrl='+url
    },
    // 退出
    exit () {
      let tag = this.GetQueryString('tag')
      if(tag==='3d32f4b0'){
        Dialog.alert({
          message: '体验版本，无此功能</br>请手机浏览器打开"http://m.nlc.cn"使用',
        }).then(() => {
          // on close
        });
      } else {
        document.body.style.overflow = 'scroll'
        Dialog.confirm({
          message: '确定退出',
          showCancelButton: true,
        }).then(() => {
          //this.$cookies.remove('accessToken')
          this.$cookies.set("accessToken",'',-1, '/');
          this.$store.commit('changeUid', '')
          this.$store.commit('changeRcardId', '')
          this.$store.commit('changeBalance', '')
          this.$store.commit('changeIdno', '')
          // on confirm
          window.location.href = 'https://sso1.nlc.cn/sso/foreign/authenticate/sso-logout?appId=90052&callback=http%3A%2F%2Fm.nlc.cn%2Fnlc-api%2Fapi%2Fnlc%2Flogout'
        }).catch(() => {
          // on cancel
        })
      }
    },
    // 获取地址栏参数
    GetQueryString(name) {
      var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if(r!=null)return  unescape(r[2]); return null;
    },
  },
  destroyed () {
    document.body.style.overflow = 'scroll'
  }
}
</script>

<style scoped>
.navigation{
  width:100%;
  position:absolute;
  left:0;
  top:0;
  z-index:999;
}
.nav{
  width:100%;
  height:.92rem;
  position:fixed;
  background:#fff;
}
.logo{
  display:inline-block;
  float:left;
  width:3.29rem;
  height:.65rem;
  background-size: 100%;
  margin:.17rem 0 0 .35rem;
}
.navigation-van{
  width:100%;
}
.van-tour{
  width:.32rem;
  height:.29rem;
  display:inline-block;
  background-size:100%;
  margin-right:.47rem;
}
.tour-close{
  width:.9rem;
  height:.9rem;
  background-size: 100%;
  float:right;
  margin:-.05rem .18rem 0 0;
}
.van-close{
  width:.9rem;
  height:.9rem;
  display:inline-block;
  background-size:100%;
  margin-right:.18rem;
}
.navigation-van >>>.van-nav-bar__right{
  padding:0;
}
.tour{
  width:.32rem;
  height:.29rem;
  display:inline-block;
  float:right;
  background-size: 100%;
  margin:.32rem .35rem 0 0;
}
.navigation-content{
  width:100%;
  height: calc(100% - .92rem);
  position:fixed;
  top:.92rem;
  background: url(../assets/img/nav-bg.png) no-repeat;
  background-size:100% 100%;
  color:#444649;
  font-size:.32rem;
  padding:.28rem 0 0 .38rem;
}
.navigation-content-list{
  width:2.14rem;
  height:2.14rem;
  background: #dfebf9;
  box-shadow: -7px -5px 14px 0px rgba(224, 239, 255, 0.5);
  border-radius: 8px;
  float:left;
  margin:.16rem .16rem 0 0;
  text-align: center;
}
.navigation-content-list .navigation-icon,.navigation-icon-login,.navigation-icon-out{
  width:.76rem;
  height:.76rem;
  display:inline-block;
}
.navigation-content-list p{
  padding:.42rem 0 .1rem 0;
  margin:0;
  text-align:center;
}
#qrcode{
  width:2rem;
  height:2rem;
  margin: 0 auto;
}
.search-code{
  position: absolute;
  left: 2.3rem;
  top: 1.8rem;
  z-index:999;
  width:2.8rem;
  height:2.6rem;
  border-radius:16px;
  background:#fff;
  padding-top:.4rem;
  font-size:.2rem;
  text-align:center;
}
.triangle_border_down{
  width:0;
  height:0;
  border-width:20px 20px 0;
  border-style:solid;
  border-color:#fff transparent transparent;
  position:absolute;
  bottom:-.2rem;
  left:.95rem;
}
>>>.van-ellipsis{
  font-family: SourceHanSerifCN-Heavy;
}
.nav-icon{
  font-size:.76rem;
}
>>>.van-nav-bar__content{
  height:.92rem;
}
>>>.van-nav-bar__title{
  font-size:.32rem;
}
>>>.van-nav-bar{
  line-height:.32rem;
}
>>>.van-nav-bar__left{
  font-size:.28rem;
}
</style>



// WEBPACK FOOTER //
// src/components/navigation.vue